'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, stage_id, data) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      stage_id: stage_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id) + '/' + stage_id,
        method: 'PUT',
        data: data
      },
      types: ['UPDATE_STAGE_START', 'UPDATE_STAGE', 'UPDATE_STAGE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/updateStage.js
// module id = 684
// module chunks = 0